var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVtex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#cd2356",
    d: "M22.203 1.793H4.28c-1.39 0-2.28 1.47-1.63 2.691l1.794 3.377h-3.25a1.2 1.2 0 0 0-.588.154a1.2 1.2 0 0 0-.435.421a1.19 1.19 0 0 0-.034 1.168l5.766 10.859c.101.19.253.35.44.462a1.2 1.2 0 0 0 1.232 0a1.2 1.2 0 0 0 .44-.463l1.566-2.933l1.965 3.701c.691 1.302 2.564 1.304 3.258.004l8.983-16.818c.635-1.19-.232-2.623-1.585-2.623m-8.05 7.185l-3.874 7.253a.8.8 0 0 1-.293.308a.8.8 0 0 1-.82 0a.8.8 0 0 1-.292-.308L5.038 9.01a.79.79 0 0 1 .02-.778a.8.8 0 0 1 .29-.281a.8.8 0 0 1 .39-.103h7.731a.8.8 0 0 1 .381.1a.8.8 0 0 1 .282.273a.77.77 0 0 1 .02.758z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVtex);
export default __webpack_public_path__ + "static/media/vtex.88baeb7ead573e13f813a1912e06fa26.svg";
export { ForwardRef as ReactComponent };